import { createSlice } from '@reduxjs/toolkit';
import en from '../language/En';
import ar from '../language/Ar';

const getSavedLang = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('lang') || 'ar';
  }
  return 'ar';
};

const savedLang = getSavedLang();
const isArabic = savedLang === 'ar';

const initialState = {
  lang: savedLang,
  dir: isArabic ? 'rtl' : 'ltr',
  translations: isArabic ? ar : en,
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      const selectedLang = action.payload;
      const isArabic = selectedLang === 'ar';
      state.lang = selectedLang;
      state.dir = isArabic ? 'rtl' : 'ltr';
      state.translations = isArabic ? ar : en;

      if (typeof window !== 'undefined') {
        localStorage.setItem('lang', selectedLang);
        localStorage.setItem('dir', state.dir);
      }
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;